export default __webpack_public_path__ + "static/media/collections_2.f84b367d.webp";